<template>
  <div class="proc-root">
    <AppHeader />
    <div class="proc-content">
      <!-- Page Header -->
      <div class="proc-page-header">
        <div>
          <span class="proc-badge">⛪ Administración</span>
          <h1 class="proc-title">Procesiones</h1>
          <p class="proc-subtitle">Gestioná las procesiones de tu hermandad</p>
        </div>
        <button class="sys-btn sys-btn--primary" @click="openDialog">
          + Agregar Procesión
        </button>
      </div>

      <div class="proc-table-wrap">

      <!-- Tabla para mostrar las procesiones -->
      <v-data-table :headers="headers" :items="procesiones" sort-by="ID_Procesion" class="elevation-1 mt-4"
        :search="search" :custom-filter="customFilter" :dark="$vuetify.theme.dark">
        <template v-slot:top>
          <v-overlay :value="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-overlay>
          <v-snackbar v-model="NotiExito" :timeout="3000" color="success" top right>
            {{ notiMessage }}
            <template v-slot:action="{ attrs }">
              <v-btn text v-bind="attrs" @click="NotiExito = false">
                Cerrar
              </v-btn>
            </template>
          </v-snackbar>
          <v-snackbar v-model="notiError" :timeout="5000" color="error" top right>
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
              <v-btn text v-bind="attrs" @click="notiError = false">
                Cerrar
              </v-btn>
            </template>
          </v-snackbar>
          <v-container>
            <v-row justify="end">
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.Fecha="{ item }">
          {{ formatTableDate(item.Fecha) }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.edit="{ item }">
          <div class="d-flex justify-center align-center">
            <v-icon color="info" small class="mr-2" @click="editProcesion(item)">mdi-pencil</v-icon>
          </div>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.actions="{ item }">
          <div class="d-flex justify-center align-center">
            <v-btn small v-if="item.Estado === 'ACTIVA'" color="error" @click="deleteProcesion(item.ID_Procesion)">
              <v-icon left>mdi-arrow-down-box</v-icon>
              Inactivar
            </v-btn>
            <v-btn small color="success" v-if="item.Estado === 'INACTIVA'" class="mr-2"
              @click="ActivateProcesion(item.ID_Procesion)">
              <v-icon left>mdi-arrow-up-box</v-icon>
              Activar
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <!-- Dialog para crear/editar procesiones -->
      <v-dialog v-model="dialog" max-width="520px">
        <div class="sys-dialog">
          <div class="sys-dialog__header">
            <span class="sys-dialog__title">{{ isEditing ? '✏️ Editar Procesión' : '+ Nueva Procesión' }}</span>
          </div>
          <div class="sys-dialog__body">
            <v-form ref="form">
              <v-text-field v-model="form.Fecha" label="Fecha de Procesión y Hora" type="datetime-local" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Ubicacion" label="Ubicación" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Brazos" label="Número de Brazos" type="number" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-textarea v-model="form.Descripcion" label="Descripción" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Costo_Inscripcion" label="Costo de Inscripción" type="number" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Costo_Aspirante" label="Costo de Aspirante" type="number" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Costo_honors" label="Costo Honor salida" type="number" :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Costo_honore" label="Costo Honor entrada" type="number" :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Mesas" label="Número de mesas" type="number" disabled :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
              <v-text-field v-model="form.Recibos_x_mesa" label="Recibos por mesa" type="number" required :dark="$vuetify.theme.dark" outlined dense class="sys-field" />
            </v-form>
          </div>
          <div class="sys-dialog__actions">
            <button class="sys-btn sys-btn--ghost" @click="closeDialog">Cancelar</button>
            <button class="sys-btn sys-btn--primary" @click="saveBtn">Guardar →</button>
          </div>
        </div>
      </v-dialog>

      <!-- Dialog de sesión expirada -->
      <v-dialog v-model="showSessionExpiredDialog" max-width="400">
        <div class="sys-dialog">
          <div class="sys-dialog__header">
            <span class="sys-dialog__title">⏱️ Sesión expirada</span>
          </div>
          <p class="sys-dialog__msg">Tu sesión ha expirado. Por favor, iniciá sesión nuevamente.</p>
          <div class="sys-dialog__actions">
            <button class="sys-btn sys-btn--primary" @click="redirectToLogin">Iniciar sesión →</button>
          </div>
        </div>
      </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import axios from "axios";

export default {
  name: "CrudProcesiones",
  components: {
    AppHeader,
  },
  data() {
    return {
      procesiones: [],
      headers: [],
      search: "",
      NotiExito: false,
      notiError: false,
      errorMessage: "",
      notiMessage: "",
      dialog: false,
      loading: false,
      isEditing: false,
      showSessionExpiredDialog: false,
      form: {
        ID_Procesion: null,
        Fecha: "",
        Ubicacion: "",
        Brazos: 0,
        Descripcion: "",
        Costo_Inscripcion: 0,
        Costo_Aspirante: 0,
        Costo_honors: 0,
        Costo_honore: 0,
        Mesas: 0,
        Recibos_x_mesa: 0
      },
    };
  },
  methods: {
    setHeaders() {

      // Obtén el valor de la cookie
      const hermandadDesc = this.$cookies.get("hermandad") || "Jesús Nazareno de la caída"; // Idioma por defecto: español
      let hermandad;
      if (hermandadDesc === "Jesús Nazareno de la caída") {
        hermandad = "JDC";
      } else if (hermandadDesc === "Virgen de dolores") {
        hermandad = "VDD";
      }

      const headersConfig = {
        JDC: [
          { text: "ID", value: "ID_Procesion" },
          { text: "Fecha de Procesión", value: "Fecha" },
          { text: "Ubicación", value: "Ubicacion" },
          { text: "Número de Brazos", value: "Brazos" },
          { text: "Descripción", value: "Descripcion" },
          { text: "Costo de Inscripción", value: "Costo_Inscripcion" },
          { text: "Costo de Aspirante", value: "Costo_Aspirante" },
          { text: "Costo Honor Mujeres 1", value: "Costo_honors" },
          { text: "Costo Honor Mujeres 2", value: "Costo_honore" },
          { text: "Estado", value: "Estado" },
          { text: "Mesas", value: "Mesas" },
          { text: "Recibos por mesa", value: "Recibos_x_mesa" },
          { text: "Editar", value: "edit", sortable: false },
          { text: "Activar/Inactivar", value: "actions", sortable: false },
        ],
        VDD: [
          { text: "ID", value: "ID_Procesion" },
          { text: "Fecha de Procesión", value: "Fecha" },
          { text: "Ubicación", value: "Ubicacion" },
          { text: "Número de Brazos", value: "Brazos" },
          { text: "Descripción", value: "Descripcion" },
          { text: "Costo de Inscripción", value: "Costo_Inscripcion" },
          { text: "Costo de Aspirante", value: "Costo_Aspirante" },
          { text: "Costo Honor Salida", value: "Costo_honors" },
          { text: "Costo Honor Entrada", value: "Costo_honore" },
          { text: "Estado", value: "Estado" },
          { text: "Mesas", value: "Mesas" },
          { text: "Recibos por mesa", value: "Recibos_x_mesa" },
          { text: "Editar", value: "edit", sortable: false },
          { text: "Activar/Inactivar", value: "actions", sortable: false },
        ]
      };

      // Asignar los headers según el idioma
      this.headers = headersConfig[hermandad] || headersConfig["JDC"];
    },
    normalizeText(text) {
      if (!text) return "";
      return text
        .normalize("NFD") // Descompone caracteres acentuados
        .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
        .toLowerCase(); // Convierte a minúsculas
    },
    customFilter(value, search) {
      if (!value) return false;
      const normalizedValue = this.normalizeText(String(value));
      const normalizedSearch = this.normalizeText(search);
      return normalizedValue.includes(normalizedSearch);
    },
    formatTableDate(dateString) {
      if (!dateString) return '';
      if (!dateString.includes('T')) return dateString; // fallback
      const [datePart, timePart] = dateString.split('T');
      const [year, month, day] = datePart.split('-');
      return `${day}/${month}/${year} ${timePart}`;
    },
    async fetchProcesiones() {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones?usuarioResponsable=${this.$cookies.get("username")}&incluirDesactivadas=true`;
      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud GET a la API original con el token en el encabezado
      axios
        .get(apiUrl, config)
        .then((response) => {
          this.procesiones = response.data.records;

          this.loading = false;
        })
        .catch((error) => {
          console.error("Error al obtener las procesiones", error);
          this.loading = false;
        });
    },
    openDialog() {
      this.isEditing = false;
      this.resetForm();
      this.dialog = true;
    },
    editProcesion(procesion) {
      this.isEditing = true;
      this.form = { ...procesion };
      this.dialog = true;
    },
    async saveBtn() {
      if (this.isEditing) {
        this.saveEditProcesion();
      } else {
        this.saveProcesion();
      }
    },
    async saveEditProcesion() {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones/${this.form.ID_Procesion}`;

      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        fecha: this.form.Fecha,
        ubicacion: this.form.Ubicacion,
        brazos: this.form.Brazos,
        descripcion: this.form.Descripcion,
        costoInscripcion: this.form.Costo_Inscripcion,
        costoAspirante: this.form.Costo_Aspirante,
        costoHonors: this.form.Costo_honors ?? 0,
        costoHonore: this.form.Costo_honore ?? 0,
        usuarioResponsable: this.$cookies.get("username"),
        recibosxMesa: this.form.Recibos_x_mesa
      };
      // Realizar solicitud POST a la API original con el token en el encabezado
      axios
        .put(apiUrl, bodyReq, config)
        .then(() => {
          this.fetchProcesiones();
          this.dialog = false;
          this.loading = false;
          this.isEditing = false;
          this.notiMessage = "La procesión ha sido Actualizada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch(() => {
          this.errorMessage = "Hubo un problema en la Actualización de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    async saveProcesion() {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones`;
      //   const apiUrl = `http://localhost:3000/dev/api/procesiones`;
      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        fecha: this.form.Fecha,
        ubicacion: this.form.Ubicacion,
        brazos: this.form.Brazos,
        descripcion: this.form.Descripcion,
        costoInscripcion: this.form.Costo_Inscripcion,
        costoAspirante: this.form.Costo_Aspirante,
        costoHonors: this.form.Costo_honors ?? 0,
        costoHonore: this.form.Costo_honore ?? 0,
        usuarioResponsable: this.$cookies.get("username"),
        recibosxMesa: this.form.Recibos_x_mesa
      };

      // Realizar solicitud POST a la API original con el token en el encabezado
      axios
        .post(apiUrl, bodyReq, config)
        .then(() => {
          this.fetchProcesiones();
          this.dialog = false;
          this.loading = false;
          this.notiMessage = "La procesión ha sido creada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch(() => {
          this.errorMessage = "Hubo un problema en la creación de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    hideNotification() {
      // Logic handled by v-snackbar automatically
    },

    async deleteProcesion(id) {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones/${id}?usuarioResponsable=${this.$cookies.get("username")}`;

      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud UPDATE a la API original con el token en el encabezado
      axios
        .delete(apiUrl, config)
        .then(() => {
          this.fetchProcesiones();
          this.loading = false;
          this.notiMessage = "La procesión ha sido inactivada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch((error) => {
          console.error("Error al inactivar la procesión", error);
          this.loading = false;
          this.errorMessage = "Hubo un problema en la inactivación de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    async ActivateProcesion(id) {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones/activate/${id}`;

      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const bodyReq = {
        usuarioResponsable: this.$cookies.get("username"),
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud UPDATE a la API original con el token en el encabezado

      axios
        .put(apiUrl, bodyReq, config)
        .then(() => {
          this.fetchProcesiones();
          this.loading = false;
          this.notiMessage = "La procesión ha sido activada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch((error) => {
          console.error("Error al Activar la procesión", error);
          this.loading = false;
          this.errorMessage = "Hubo un problema en la activación de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    closeDialog() {
      this.dialog = false;
    },
    resetForm() {
      this.form = {
        id: null,
        fechaProcesion: "",
        ubicacion: "",
        numeroBrazos: 0,
        descripcion: "",
        costoInscripcion: 0,
      };
    },
    redirectToLogin() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
      // Redirige al usuario a la página de inicio de sesión
      window.location.href = "/login";
    },
  },
  mounted() {
    this.setHeaders();
    this.fetchProcesiones();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

.proc-root {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: var(--sys-bg);
}

.proc-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 90px 32px 60px;
}

/* ── Page Header ── */
.proc-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}
.proc-badge {
  display: inline-block;
  background: rgba(123,47,247,0.15);
  border: 1px solid rgba(123,47,247,0.35);
  color: #c4a0ff;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.03em;
}
.proc-title {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: var(--sys-text-primary);
  margin-bottom: 6px;
}
.proc-subtitle {
  color: var(--sys-text-secondary);
  font-size: 0.95rem;
  margin: 0;
}

/* ── Table Wrap ── */
.proc-table-wrap {
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 8px;
  backdrop-filter: blur(12px);
  overflow: hidden;
}

/* Override Vuetify data table for dark/light ── */
::v-deep .v-data-table {
  background: transparent !important;
}
::v-deep .v-data-table .v-data-table__wrapper table {
  background: transparent !important;
}
[data-theme="dark"] ::v-deep .v-data-table thead tr th {
  background: rgba(123,47,247,0.12) !important;
  color: rgba(255,255,255,0.7) !important;
}
::v-deep .v-data-table thead tr th {
  background: var(--sys-table-header) !important;
  color: var(--sys-text-secondary) !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.78rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-table tbody tr {
  background: transparent !important;
  transition: background 0.2s !important;
}
::v-deep .v-data-table tbody tr:hover {
  background: var(--sys-table-row-hover) !important;
}
::v-deep .v-data-table tbody tr td {
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-footer {
  background: transparent !important;
  border-top: 1px solid var(--sys-card-border) !important;
  color: var(--sys-text-secondary) !important;
}
::v-deep .v-data-footer .v-select__selection {
  color: var(--sys-text-primary) !important;
}
[data-theme="dark"] ::v-deep .v-text-field input,
[data-theme="dark"] ::v-deep .v-text-field label,
[data-theme="dark"] ::v-deep .v-text-field .v-input__slot {
  color: rgba(255,255,255,0.7) !important;
}
::v-deep .v-text-field .v-input__slot {
  border-color: rgba(123,47,247,0.3) !important;
}

/* Snackbars */
::v-deep .v-snack__wrapper { font-family: 'Inter', sans-serif !important; border-radius: 12px !important; }

/* ── Botones de acción en tabla ── */
::v-deep .v-btn.error { background: rgba(239,68,68,0.15) !important; border: 1px solid rgba(239,68,68,0.3) !important; color: #fca5a5 !important; }
::v-deep .v-btn.success { background: rgba(74,222,128,0.15) !important; border: 1px solid rgba(74,222,128,0.3) !important; color: #86efac !important; }

/* ── Shared dialog / buttons ── */
.sys-dialog {
  background: var(--sys-dialog-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 28px 24px;
  font-family: 'Inter', sans-serif;
}
.sys-dialog__header { margin-bottom: 20px; }
.sys-dialog__title { font-size: 1.2rem; font-weight: 800; color: var(--sys-text-primary); display: block; }
.sys-dialog__msg { color: var(--sys-text-secondary); font-size: 0.92rem; margin: 0 0 24px; }
.sys-dialog__body { margin-bottom: 24px; }
.sys-dialog__actions { display: flex; justify-content: flex-end; gap: 12px; }

.sys-btn {
  padding: 10px 22px;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}
.sys-btn--primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123,47,247,0.35);
}
.sys-btn--primary:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(123,47,247,0.5); }
.sys-btn--ghost {
  background: transparent;
  color: var(--sys-text-secondary);
  border: 1px solid var(--sys-card-border);
}
.sys-btn--ghost:hover { background: var(--sys-input-bg); color: var(--sys-text-primary); }

@media (max-width: 768px) {
  .proc-content { padding: 80px 16px 40px; }
  .proc-page-header { flex-direction: column; align-items: flex-start; }
}
</style>
